import { bindUrl, request } from "./request";

export function getSupplyList() {
  return request({
    url: bindUrl("/svc-oil/supply/list", {}),
    method: "GET"
  });
}
//业务员下订单-国际贸易
export function addNewOrder(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/admin/internation-temp/order/create", {}),
    method: "POST",
    data: bodyParams
  });
}
